module.exports = __webpack_public_path__ + "img/74.82b85f50.jpg";